var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSquaresFour = function SvgIconSquaresFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5a1 1 0 0 0-1 1v5.625a1 1 0 0 0 1 1h5.625a1 1 0 0 0 1-1V4.5a1 1 0 0 0-1-1zm1 5.625V5.5h3.625v3.625zM13.875 3.5a1 1 0 0 0-1 1v5.625a1 1 0 0 0 1 1H19.5a1 1 0 0 0 1-1V4.5a1 1 0 0 0-1-1zm1 5.625V5.5H18.5v3.625zM3.5 13.875a1 1 0 0 1 1-1h5.625a1 1 0 0 1 1 1V19.5a1 1 0 0 1-1 1H4.5a1 1 0 0 1-1-1zm2 1V18.5h3.625v-3.625zM13.875 12.875a1 1 0 0 0-1 1V19.5a1 1 0 0 0 1 1H19.5a1 1 0 0 0 1-1v-5.625a1 1 0 0 0-1-1zm1 5.625v-3.625H18.5V18.5z"
  }))));
};
export default SvgIconSquaresFour;